import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Modal, Card, CardContent, Stack, Button, Portal, Typography, TextField, LinearProgress, Alert } from '@mui/material';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function ConfirmExit ({ open, handleClose, url }) {
  const navigate = useNavigate();

  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <Card sx={{ ...style, width: '300px' }}>
          <CardContent>
            <Typography variant="body1" textAlign="center">
              Czy na pewno chcesz wyjść z formularza? Dane nie zostaną zapisane.
            </Typography>
            <Box height={20} />
            <Stack flexDirection="row" justifyContent="space-around">
              <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Nie</Button>
              <Button sx={{ flexGrow: 0.4 }} variant="contained" onClick={() => {
                navigate(url);
                handleClose();
              }}>Tak</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
